import React from 'react'
import isEmpty from 'lodash/isEmpty'
import capitalize from 'lodash/capitalize'
import {UniLink} from '../../../core/components/unilink/index'
import InteractiveContentBlocks from '../../../core/components/interactive-content-blocks/InteractiveContentBlocks'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import DefaultUserContentPicture from '../../../core/components/default-user-picture/DefaultUserContentPicture'
import Text from '../../../core/components/typography/text/Text'
import './leafInteractiveContent.css'
import { Redirect } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { deleteContent } from '../../../util/http'


function ContentHeader({activeContent, isLoggedIn, toggleVote, showRegister}) {
  const {authors, author, voteCount, type, id, contentType, currentUserHasVoted} = activeContent
  // let authorString = ''
  const mainAuthor = authors ? authors[0] : author ? author : null
  // const voteCountHeartClassNames = ['content-select__votecount-heart']
  const voteCountClassNames = ['leaf-content-header__votecount','content-select__votecount--clickable']


  if (currentUserHasVoted) {
    voteCountClassNames.push('content-select__votecount--voted')
  }
  return (
    <div className='leaf-interactive-content__header'>
      {
        mainAuthor
          ?
          <div className='leaf-interactive-content__header-body'>
            <div className='leaf-interactive-content__header-user'>
              <UniLink
                to={`/user/${mainAuthor.id}`}>
                <DefaultUserContentPicture displayName={mainAuthor.displayName} userID={mainAuthor.id} className='leaf-interactive-content__profile-pic' />
              </UniLink>
              <div>
                <UniLink
                  to={`/user/${mainAuthor.id}`}>
                  <Text fontWeight='medium' size='md'>
                    {mainAuthor.displayName}
                  </Text>
                </UniLink>
                <Text size='xs' color='coolGray' fontWeight='medium'>
                  { (capitalize(contentType) === 'Video') ? <FontAwesomeIcon icon={['fa', 'play-circle']} className='leaf-interactive-content__type' /> : <FontAwesomeIcon icon={['fa', 'book-open']} className='leaf-interactive-content__type' /> }
                  {capitalize(contentType)}
                </Text>
              </div>
            </div>
            <div
              className={voteCountClassNames.join(' ')}
              onClick={()=>{
                if (isLoggedIn) {
                  toggleVote(type, id)
                } else {
                  showRegister(()=>{
                    toggleVote(type, id)
                  })
                }
              }}>
              { currentUserHasVoted ? <FontAwesomeIcon icon={['fa', 'heart']} className='leaf-interactive-content__votecount-heart' /> : <FontAwesomeIcon icon={['far', 'heart']} className='leaf-interactive-content__votecount-heart' /> }
              {voteCount}
            </div>
          </div>
          : null
      }
    </div>
  )
}

function LeafContentFooter({isLoading, toggleVote, openShare, openReport, openEditor, showRegister, activeContent, isLoggedIn, isModerator}) {
  const voteCountClassNames = ['leaf-content-header__votecount','content-select__votecount--clickable']
  const deleteExplanation = function(type, id){
    if (window.confirm('You are about to delete an explanation. This cannot be undone. Are you sure you want to do this?')) {
      deleteContent(`/api/content/${ type }/${ id }`)
      window.location.reload()
    }
  }
  if (isLoading){
    return (
      <div className='leaf-interactive-content__footer'>
        <UniLink ><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> Report</UniLink>
        {
          openShare
            ? <UniLink ><FontAwesomeIcon icon={['fa', 'share-alt']} /> Share</UniLink>
            : null
        }
        <UniLink
          className={voteCountClassNames.join(' ')}>
          <div>
            <FontAwesomeIcon icon={['fa', 'heart']} className='leaf-interactive-content__votecount-heart' />
          </div>
          Like
        </UniLink>
      </div>
    )
  }
  const {voteCount, type, id, currentUserHasVoted} = activeContent
  if (currentUserHasVoted) {
    voteCountClassNames.push('content-select__votecount--voted')
  }
  
  return (
    <div className='leaf-interactive-content__footer'>
      {
        isLoggedIn && isModerator
        ? 
          <UniLink onClick={()=>deleteExplanation(type,id)}>
            <FontAwesomeIcon icon={['fa', 'trash-alt']} /> <Text size='sm'>Delete</Text>
          </UniLink>
        : 
          null
      }
      <UniLink onClick={()=>openReport(activeContent)}><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> <Text size='sm'>Report</Text></UniLink>
      {
        openShare
          ? <UniLink onClick={() => openShare(id, type) }><FontAwesomeIcon icon={['fa', 'share-alt']} /> <Text size='sm'>Share</Text></UniLink>
          : null
      }
      <UniLink
        className={voteCountClassNames.join(' ')}
        onClick={()=>{
          if (isLoggedIn) {
            toggleVote(type, id)
          } else {
            showRegister(()=>{
              toggleVote(type, id)
            })
          }
        }}>
        <div className='leaf-content-header__votecount-box'>
          { currentUserHasVoted ? <FontAwesomeIcon icon={['fa', 'heart']} className='leaf-interactive-content__votecount-heart' /> : <FontAwesomeIcon icon={['far', 'heart']} className='leaf-interactive-content__votecount-heart' /> }
          {voteCount}
        </div>
        <Text size='sm'>Like</Text>
      </UniLink>
      {
        isLoggedIn && isModerator
        ? 
          <UniLink to={`/editor/edit/${type}/${id}`}>
            <FontAwesomeIcon icon={['fa', 'pencil-alt']} /> <Text size='sm'>Edit</Text>
          </UniLink>
        : 
          null
      }
    </div>
  )
}

class LeafInteractiveContent extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      collapsible: props.collapsible,
      isCollapsed: true
    }

    this.checkCollapsible = this.checkCollapsible.bind(this)
    this.toggleCollapse = this.toggleCollapse.bind(this)
  }
  checkCollapsible(e) {
    const {isFirst} = this.props
    const {collapsible} = this.state
    const fistCollapsibleHeight = 816 // 51 rem
    const collapsibleHeight = 496 // 31 rem
    if (e && collapsible) { // Check whether the content is collapsible based on the actual height.
      this.setState({
        collapsible: e.clientHeight > (isFirst ? fistCollapsibleHeight : collapsibleHeight)
      })
    }
  }
  toggleCollapse(e) {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    })
  }
  render() {
    const {entityExists, isLoading, activeContent, className, as, openEditor, openShare, topicId, openReport, isLoggedIn, showRegister, errorToast, toggleVote, isFirst, isModerator} = this.props
    const {collapsible} = this.state
    if (entityExists === false) {
      // Original: Redirect to 404 when cant find explanation
      //return <Redirect to={{pathname: '/404', state : {problem: "Invalid explanation id"}}} />;
      errorToast()
      return <Redirect to={`/t/${topicId}`} />
    } else if (!isEmpty(activeContent)) {
      const {renderedContent, type, id} = activeContent
      const {isCollapsed} = this.state

      const classNames = ['leaf-interactive-content', className]
      // const typeName = type === 'problem_solution' ? 'solution' : type.split('_').join(' ')
      if (isCollapsed && collapsible) {
        classNames.push(isFirst ? 'leaf-interactive-content--collapsed-first' : 'leaf-interactive-content--collapsed')
      }

      return (
        <div className={classNames.join(' ')}>
          <ContentHeader activeContent={activeContent} isLoggedIn={isLoggedIn} showRegister={showRegister} toggleVote={toggleVote} />
            <InteractiveContentBlocks
              content={renderedContent}
              type={type}
              id={id}
              as={as}
            />
          {
            // collapsible &&
            // <button
            //   onClick={this.toggleCollapse}
            //   className={isCollapsed ? 'leaf-content-collapse-toggle leaf-content-collapse-toggle--collapsed' : 'leaf-content-collapse-toggle'}>
            //   <Text color='midGray' fontWeight='medium'>
            //     {
            //       isCollapsed
            //         ? <Box display='flex' alignItems='center'><Box marginRight={4}>Expand</Box><FontAwesomeIcon icon={['fa', 'angle-down']} /></Box>
            //         : <Box display='flex' alignItems='center'><Box marginRight={4}>Collapse</Box><FontAwesomeIcon icon={['fa', 'angle-up']} /></Box>
            //     }
            //   </Text>
            // </button>
          }
          <LeafContentFooter
            isLoading={isLoading}
            isLoggedIn={isLoggedIn}
            toggleVote={toggleVote}
            openShare={openShare}
            openReport={openReport}
            openEditor={openEditor}
            showRegister={showRegister}
            activeContent={activeContent} 
            isModerator={isModerator}
            />
        </div>
      )
    } else if (isLoading) {
      const classNames = ['leaf-interactive-content', 'leaf-interactive-content--loading', className]
      return (
        <div className={classNames.join(' ')}>
          <div className='leaf-interactive-content__header'>
            <div className='leaf-interactive-content__authors' />
          </div>
          <div className='leaf-interactive-content__loading-space'>
            <LoadingSpinner delay={200} />
          </div>
          <LeafContentFooter isLoading={isLoading} />
        </div>
      )
    }
    return null
  }
}

export default LeafInteractiveContent



// WEBPACK FOOTER //
// ./src/domains/topic/components/LeafInteractiveContent.js